/* @flow */

import _ from 'lodash';
import { compose, branch, renderComponent, withProps } from 'recompose';

import Loading from '../components/Loading';

const withLoader = compose(
  withProps({
    col: 3,
    row: 3,
    size: 72,
    text: 'Loading Data',
    textStyle: {
      paddingTop: '1.5rem',
      paddingBottom: '0',
    },
  }),
  branch(props => props.loading, renderComponent(Loading), _.identity),
);

export default withLoader;



// WEBPACK FOOTER //
// ./src/hoc/withLoader.js